import React from "react";

//icons
import { IconLibrary } from "../../../../interfaces/icon/IconLibrary";
import Icon from "../../../global/icons/Icon";

//interfaces
import { ILikeButton } from "./LikeButton";



interface ILikesButton extends ILikeButton {
    numberOfLikes: number
}



const LikesButton = ({isDisabled, ariaLabel, onButtonClick, includeText, isActive, numberOfLikes, buttonText}: ILikesButton) => {
    const text : string = numberOfLikes === 1 ? `1 like` : `${numberOfLikes} likes`

    return (
        <button
            className={`social-likes-button`}
            disabled={isDisabled}
            aria-label={ariaLabel}
            onClick={onButtonClick}
        >
            <Icon iconName={isActive ? IconLibrary.LIKE_ACTIVE : IconLibrary.LIKE} sizeInPx="12"/>
            {includeText && (buttonText ?? text)}        
        </button>
    );
};

export default LikesButton